import { Global } from './../../models/global';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardStart  {
  constructor(private _global:Global, private _router:Router){
  }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if(this._global.isUserLanguageSet()){             
             return true;
          }else{
            this._router.navigate(['/start']);
          }
       
  } 
 
}
